








import { Vue, Component } from 'vue-property-decorator'
import ModalManager from '~/components/modals/Index.vue'

@Component({ components: { ModalManager } })
export default class App extends Vue {
    get bodyHeight() {
        return document.getElementsByTagName('body')[0].clientHeight
    }
    get deviceHeight() {
        return document.documentElement.clientHeight
    }

    handleScroll(event: any) {
        if (this.bodyHeight - (this.deviceHeight + event.pageY) < 260) {
            const element = document.getElementsByClassName('crisp-kquevr')[0]
            element.setAttribute('style', 'padding-bottom:40px !important')
        }
    }

    created() {
        this.$store.dispatch('auth/fetchOwnProfile')
        window.addEventListener('scroll', this.handleScroll)
    }

    destroyed() {
        window.removeEventListener('scroll', this.handleScroll)
    }
}
